import { createEvent, restore, sample } from 'effector'
import { libraryGridFavoritesMoviesWidget } from '~/widgets/library/grid/favorites/movies'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridFavoritesMoviesWidget.$isGridFavoritesMoviesLoading,
  target: setContentLoading,
})
